import React from 'react'
import { getLevelKeyFromCode } from './utils/progressUtils'
import { LEVEL } from './utils/constants/levels'
import { STATUS } from './utils/constants/statuses'
import { formatDisplayDate } from './utils/displayUtils'
import LevelProgressPopover from './LevelProgressPopover'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  LevelProgressBar as StyledLevelProgressBar,
  LevelProgressContent,
  LevelProgressText,
  LevelProgressCount,
  DateInfo,
  DateLabel,
  DateValue,
  DateDivider
} from './Styles/ProgressTracker.styles'

const LEVEL_NAMES = {
  [LEVEL.QUALIFYING]: 'Qualifying',
  [LEVEL.LEVEL_1]: 'Level 1',
  [LEVEL.LEVEL_2]: 'Level 2',
  [LEVEL.LEVEL_3]: 'Level 3'
}

const LevelProgressBar = ({ activeLevel, programHistory = [], levelState }) => {
  const { latestProgram } = useMembershipJourneyContext()
  const { levelExpirationDate, levelCode: currentLevelCode } = latestProgram || {}

  if (activeLevel === LEVEL.QUALIFYING) {
    return null
  }
  
  const levelName = LEVEL_NAMES[activeLevel] || 'Level'
  
  const activeLevelProgram = programHistory.find(
    p => getLevelKeyFromCode(p.levelCode) === activeLevel
  )
  
  if (!activeLevelProgram || !activeLevelProgram.startDate) {
    return null
  }
  
  const completionDate = activeLevelProgram.endDate || (activeLevelProgram.levelCode === currentLevelCode ? levelExpirationDate : null)
  
  if (!completionDate) {
    return null
  }
  
  const isCompleted = activeLevelProgram.completeCode?.toLowerCase() === STATUS.COMPLETE
  const startDate = formatDisplayDate(activeLevelProgram.startDate)
  const endDate = formatDisplayDate(completionDate)
  
  return (
    <StyledLevelProgressBar>
      <LevelProgressContent>
        {isCompleted ? (
          <>
            <DateInfo>
              <DateLabel>{levelName} Started: </DateLabel>
              <DateValue>{startDate}</DateValue>
            </DateInfo>
            <DateDivider />
            <DateInfo>
              <DateLabel>{levelName} Completed: </DateLabel>
              <DateValue>{endDate}</DateValue>
            </DateInfo>
          </>
        ) : (
          <LevelProgressText>
            {levelName} Completion Deadline: {' '}
            <LevelProgressCount>{endDate}</LevelProgressCount>
          </LevelProgressText>
        )}
      </LevelProgressContent>
      <LevelProgressPopover 
        programHistory={programHistory} 
        levelState={levelState} 
      />
    </StyledLevelProgressBar>
  )
}

export default LevelProgressBar

